module.exports = __webpack_public_path__ + "static/07-70bce5ca53467e549e839169aa15a980.jpg";